import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { mainUrl } from "../../api/client/api";
import { Helmet } from "react-helmet-async";

const BlogDetails = () => {
    const { id } = useParams();
    const [blog, setBlog] = useState(null);
    const baseURL = window.location.origin;

    useEffect(() => { window.scrollTo(0, 0); fetchBlogDetails(); }, []);

    const fetchBlogDetails = async () => {
        try {
            const res = await axios.get(`${mainUrl}api/blog/getblog/${id}`);
            if (res?.data?.status) { setBlog(res.data.data) };
        }
        catch (error) { console.log("BLOG DETAILS ERROR:", error); }
    };

    if (!blog) return <h2 style={{ textAlign: "center", marginTop: "50px" }}>Loading...</h2>;

    return (
        <section className="content-section">
            <Helmet>
                <title>{blog?.metaTitle || ""}</title>
                <meta name="description" content={blog?.metaDescription || ""} />
                <meta name="keywords" content={blog?.keyword || ""} />
                <meta property="og:title" content={blog?.metaTitle || ""} />
                <meta property="og:description" content={blog?.metaDescription || ""} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${baseURL}/blog-details/${blog?.id}`} />
                <link rel="canonical" href={`${baseURL}/blog-details/${blog?.id}`} />
            </Helmet>
            <div className="container" style={{ maxWidth: "1200px" }}>
                <Link to={`/blogs`} className="btn btn-sm mb-5" style={{ backgroundColor: '#000', color: "#fff" }}>
                    <span style={{ marginRight: "5px" }}>←</span>Back
                </Link>
                <img src={mainUrl + blog.blogImg} alt={blog.imgAlt} title={blog.imgTitle} style={{ width: "100%", maxHeight: "400px", objectFit: "cover", border: "3px solid #4e484852", padding: "5px", borderRadius: "10px", marginBottom: "25px" }} />
                <h1 style={{ fontSize: "20px", marginBottom: "10px", color: "#202124cf" }}>{blog.blogHeading}</h1>
                <h3 style={{ color: "#777", fontSize: "18px", marginBottom: "18px", fontWeight: "normal" }}>{blog.blogTitle}</h3>
                <div style={{ background: "#f8f9fa", padding: "20px", borderRadius: "8px", fontSize: "16px", lineHeight: "1.8", whiteSpace: "pre-line" }}>
                    {blog.blogContent}
                </div>
            </div>
        </section>
    );
};

export default BlogDetails;
